import { AppConfigComponents } from '../components';
import { Footer } from './footer/footer';
import { SafeAreaDiv } from './utils/views/safeAreaDiv';

export const components: AppConfigComponents = {
    footer: Footer,
    safeAreaDiv: SafeAreaDiv
};
